import React, { PureComponent, ErrorInfo, ReactNode } from "react";
import Typography from "@material-ui/core/Typography";

interface Props {
  children?: ReactNode;
  fallback?: string;
}

interface State {
  hasError: boolean;
}

export const DEFAULT_FALLBACK = "Something went wrong...";

class ErrorBoundary extends PureComponent<Props, State> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false
    };
  }

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Typography
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {this.props.fallback || DEFAULT_FALLBACK}
        </Typography>
      );
    }

    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
